import React from "react";
import "../styles/AutoDebitPopup.css";
import { useTranslation } from "react-i18next";

const AutoDebitConfirmationPopup = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation(); // Use translation hook

  return (
    <div className="auto-debit-popup-overlay">
      <div className="auto-debit-popup">
        <h4 className="registerautodebit-popup">{t("registerAutoDebit")}</h4>
        <p style={{ marginTop: "20px", fontSize: "14px", justifyContent: "flex-start" }}>
          {t("confirmationText")}
        </p>
        <div className="popup-buttons" style={{ marginTop: "20px" }}>
          <button className="cancel-btn" onClick={onCancel}>{t("keepManual")}</button>
          <button className="confirm-btn" onClick={onConfirm}>{t("confirm")}</button>
        </div>
      </div>
    </div>
  );
};

export default AutoDebitConfirmationPopup;
